export enum MunicipalMessengerAuthorizations {
  MessiEx = 'OP_MESSI',
  MessiAdmin = 'ADMIN_MESSI',
  MessiStaff = 'STAFF_MESSI',
  MessiMessenger = 'MES_MESSI',
}

export const MunicipalMessengerExecute = [MunicipalMessengerAuthorizations.MessiEx];
export const MunicipalMessengerAdmin = [MunicipalMessengerAuthorizations.MessiAdmin];
export const MunicipalMessengerStaff = [MunicipalMessengerAuthorizations.MessiStaff];
export const MunicipalMessengerMessenger = [MunicipalMessengerAuthorizations.MessiMessenger];

export const MunicipalMessengerAuthorizationsList = [
  ...MunicipalMessengerExecute,
  ...MunicipalMessengerAdmin,
  ...MunicipalMessengerStaff,
  ...MunicipalMessengerMessenger,
];

export const MunicipalMessengerAdminAuthorizationsList = [
  ...MunicipalMessengerStaff,
  ...MunicipalMessengerAdmin,
];

export const MunicipalMessengerNoMessengerAuthorizationsList = [
  ...MunicipalMessengerExecute,
  ...MunicipalMessengerAdmin,
  ...MunicipalMessengerStaff,
];

export const MunicipalMessengerAdminOrMessengerAuthorizationsList = [
  ...MunicipalMessengerMessenger,
  ...MunicipalMessengerAdmin,
  ...MunicipalMessengerStaff,
];
